import * as React from 'react'
import IconPanel from '@mulesoft/anypoint-icons/lib/Icon'
import UrlDownloader from '@mulesoft/monitoring-center-components/lib/components/common/UrlDownloader'
import ArchiveAPIService from '../../remote-api/ArchiveAPIService';
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip'

export type ValueProps = {
  size: string
  fileName: string
  fileUrl: string
  token: string
  isDisabled:boolean
  isVisited: boolean
}

export type EventProps = {
  onDownload: () => any
}

export type Props = ValueProps & EventProps

export default class RawDataPageSizeCell extends React.Component<Props> {

  render() {
    const {size,  fileUrl, fileName, token, isVisited, isDisabled, onDownload} = this.props
    const archiveAPIDNS = ArchiveAPIService.getQueryRouterDNS()
    const url = `${archiveAPIDNS}/monitoring/archive/api/v1/${fileUrl}`
    const fill = isDisabled ? '#cccccc' : isVisited ? '#9a63f9' : '#58595a'

    return (
        <div className={'value-button-container'}>
          <div className={'size-container'}>{size}</div>
          {isDisabled  ?
              (<Tooltip content={'Unable to download log files over 10MB'} style={{ height:'30px', padding:'2px', marginRight:'2px'}} position={'left'} >
                <IconPanel name={'download'} fill={fill} />
              </Tooltip>) :
              (<UrlDownloader url={url} fileName={fileName} token={token} onDownload={onDownload}>
                <IconPanel testId={'download-log-file-icon'} className={'download-file-icon'} name={'download'} fill={fill} />
              </UrlDownloader>)}
        </div>
    )
  }
}
